// extracted by css-extract-rspack-plugin
export default {"Box":"repo-list-module__Box__NcyvS","Text":"repo-list-module__Text__klXJz"};